<template>
  <el-menu-item v-if="isLeaf" :index="route.resolvedPath">
    <i v-if="route.meta && route.meta.icon" :class="route.meta.icon"></i>
    <span>{{ route.meta && route.meta.title }}</span>
  </el-menu-item>

  <el-submenu v-else :index="route.resolvedPath">
    <template slot="title">
      <i v-if="route.meta && route.meta.icon" :class="route.meta.icon"></i>
      <span>{{ route.meta && route.meta.title }}</span>
    </template>
    <menu-item
      v-for="child in route.children"
      :key="child.resolvedPath"
      :route="child"
    />
  </el-submenu>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  computed: {
    isLeaf() {
      return !this.route.children || this.route.children.length === 0
    }
  }
}
</script>
